import "./Project.css"
import ProjectItem from "./ProjectItem";
import Fade from 'react-reveal/Fade';
import project_list from "./project_list";
import Slide from 'react-reveal/Slide';

const Project = () =>{
    return (        
    <div id="projects" className="project-container">
        <Fade left><p className="project-title">My <span className="highlighted-text">Projects</span></p>
        <hr></hr></Fade>
        {project_list.map((project,index)=>{
            if(index %2 === 0){
                return <Slide right><ProjectItem github_link={project.github_link} link={project.link} name={project.name} content={project.content} stack={project.stack} image={project.image}/></Slide>
            }else{
                return (
                    <Slide left><ProjectItem github_link={project.github_link} link={project.link} name={project.name} content={project.content} stack={project.stack} image={project.image}/></Slide>
                )
            }
        })}

    </div>  
    )
}

export default Project;